import { Menu, X } from 'lucide-react';
import { type ReactNode, useEffect, useRef, useState } from 'react';

/**
 * Barra inferior de los paneles en el teléfono (arquitectura 2.16): los cuatro destinos del rol a
 * un pulgar de distancia y «Más» abre el menú completo en una hoja que sube desde abajo. Cada
 * panel le pasa sus enlaces ya hechos (NavLink del router), así este paquete no depende de él.
 */
export function BarraInferior({
  principales,
  mas,
  titulo = 'Menú',
}: {
  /** Hasta cuatro enlaces con `className="ui-barra-inferior-enlace"`, ícono y texto. */
  principales: ReactNode;
  /** El menú completo (se muestra en la hoja). */
  mas: ReactNode;
  titulo?: string;
}) {
  const [abierta, setAbierta] = useState(false);
  const hoja = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!abierta) return;
    const alTeclear = (e: KeyboardEvent) => e.key === 'Escape' && setAbierta(false);
    document.addEventListener('keydown', alTeclear);
    hoja.current?.querySelector<HTMLElement>('a, button')?.focus();
    return () => document.removeEventListener('keydown', alTeclear);
  }, [abierta]);
  return (
    <>
      <nav className="ui-barra-inferior" aria-label="Accesos rápidos">
        {principales}
        <button
          type="button"
          className="ui-barra-inferior-enlace"
          aria-expanded={abierta}
          aria-controls="ui-hoja-menu"
          onClick={() => setAbierta((a) => !a)}
        >
          <Menu size={22} strokeWidth={1.75} aria-hidden="true" />
          <span>Más</span>
        </button>
      </nav>
      {abierta && (
        <div className="ui-hoja-fondo" onClick={() => setAbierta(false)} aria-hidden="true" />
      )}
      <div
        id="ui-hoja-menu"
        ref={hoja}
        className="ui-hoja"
        role="dialog"
        aria-modal="true"
        aria-label={titulo}
        hidden={!abierta}
        // Al elegir un destino la hoja se cierra sola.
        onClickCapture={(e) => {
          if ((e.target as HTMLElement).closest('a')) setAbierta(false);
        }}
      >
        <header>
          <strong>{titulo}</strong>
          <button type="button" className="ui-hoja-cerrar" onClick={() => setAbierta(false)}>
            <X size={20} aria-hidden="true" />
            <span className="ui-oculto">Cerrar</span>
          </button>
        </header>
        {mas}
      </div>
    </>
  );
}
